import React from 'react';
import { NodeCard } from './NodeCard';

// Per-cluster grid section with a header showing cluster name + activity counts.
export function ClusterNodeSection({ clusterId, cluster, counts, resources, network40g, nodeUsage }) {
  const c = counts || { running: 0, pending: 0 };
  // Live node occupancy for this cluster (a spanning job from another cluster can
  // make these nodes busy even when this cluster "owns" 0 running jobs).
  const busyCount = (cluster.members || []).filter(n => nodeUsage?.[n]?.busy).length;
  const total = (cluster.members || []).length;
  return (
    <div style={{ marginBottom: 24 }}>
      <div style={{
        display: 'flex', alignItems: 'center', justifyContent: 'space-between',
        padding: '8px 4px', marginBottom: 12,
        borderBottom: `1px solid ${cluster.color}33`,
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
          <span style={{ width: 8, height: 8, borderRadius: '50%', backgroundColor: cluster.color }} />
          <span style={{
            color: cluster.color, fontSize: 12, fontWeight: 700,
            letterSpacing: 1, textTransform: 'uppercase',
          }}>{cluster.label}</span>
          <span style={{ color: '#6b7280', fontSize: 12 }}>
            · {cluster.members.length} node{cluster.members.length !== 1 ? 's' : ''}
            · head: <code style={{ color: '#9ca3af' }}>{cluster.head}</code>
          </span>
        </div>
        <div style={{ display: 'flex', gap: 14, fontSize: 12, color: '#9ca3af' }}>
          <span><span style={{ color: '#22c55e', fontWeight: 700 }}>{c.running}</span> running</span>
          <span><span style={{ color: '#eab308', fontWeight: 700 }}>{c.pending}</span> queued</span>
          <span><span style={{ color: busyCount ? '#22d3ee' : '#6b7280', fontWeight: 700 }}>{busyCount}/{total}</span> in use</span>
        </div>
      </div>
      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
        gap: 16,
      }}>
        {cluster.members.map(node => (
          <NodeCard
            key={node}
            node={node}
            data={resources.find(r => r.node === node) || {}}
            network40g={network40g}
            nodeUsage={nodeUsage}
            clusterId={clusterId}
            clusterCount={counts}
            isMobile={false}
          />
        ))}
      </div>
    </div>
  );
}

// Nodes that aren't part of any scheduling cluster — rendered as a separate section.
export function UnassignedNodeSection({ nodes, resources, network40g, nodeUsage }) {
  return (
    <div style={{ marginBottom: 24 }}>
      <div style={{
        display: 'flex', alignItems: 'center', gap: 10,
        padding: '8px 4px', marginBottom: 12,
        borderBottom: '1px solid #37415133',
      }}>
        <span style={{ width: 8, height: 8, borderRadius: '50%', backgroundColor: '#6b7280' }} />
        <span style={{
          color: '#9ca3af', fontSize: 12, fontWeight: 700,
          letterSpacing: 1, textTransform: 'uppercase',
        }}>Unassigned</span>
        <span style={{ color: '#6b7280', fontSize: 12 }}>
          · {nodes.length} node{nodes.length !== 1 ? 's' : ''} not in a scheduling cluster
        </span>
      </div>
      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
        gap: 16,
      }}>
        {nodes.map(node => (
          <NodeCard
            key={node}
            node={node}
            data={resources.find(r => r.node === node) || {}}
            network40g={network40g}
            nodeUsage={nodeUsage}
            clusterId={null}
            clusterCount={null}
            isMobile={false}
          />
        ))}
      </div>
    </div>
  );
}
